import axios from 'axios';
import { FETCH_REMOVED_ITEMS } from '../types';
import { notification } from '../../utils';

export const fetchRemovedItems = () => async (dispatch) => {
  try {
    const allRemovedItems = await axios.get('/api/removed_items');
    const getItems = await allRemovedItems.data;
    dispatch({
      type: FETCH_REMOVED_ITEMS,
      payload: getItems,
    });
  } catch (error) {
    notification('error', 'An error occured!');
  }
};
